import styled from 'styled-components';
import { createTheme } from '@mui/material/styles';
import HelpIcon from '@mui/icons-material/Help';

export const StyleHelpIcon = styled(HelpIcon)`
  color: #b20425;
  margin-left: 5px;
  cursor: pointer;
`;

export const theme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '1em',
          color: 'black',
          backgroundColor: 'white',
          '& .MuiTooltip-arrow': {
            color: 'black',
          },
          padding: '20px',
          background: '#FFFFFF',
          border: '1px solid #A8A8A8',
          borderRadius: '5px',
          boxShadow: '2px 2px 3px #999',
          fontWeight: 400,
          lineHeight: '19px',
        },
      },
    },
  },
});
